module.exports = __webpack_public_path__ + "static/media/4955c571.jpg";